export default class MessageThreadDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), lastMessageDate: new Date(json.lastMessageDate) });
    }
}
